import { MixedItem, RBAssetType } from 'store/railsBuilder/reducer.types';

import { DetailsRequestUrlType } from 'screens/Detail/types';

import { BtvProgramme } from '../types';
import getRBAssetChannelId from './getRBAssetChannelId';

function getRBBtvProgrammeDetailsParams(
    btvProgramme: BtvProgramme,
): MixedItem['detailsPageParams'] {
    const { id, contentRef, type, editorial } = btvProgramme;
    const channelId = getRBAssetChannelId(btvProgramme);

    if (editorial?.seriesRef) {
        return {
            filterType: DetailsRequestUrlType.PROGRAM,
            id,
            channelId,
            seriesId: editorial.seriesRef,
            programId: editorial.technicals?.[0]?.ProgramId,
            season: editorial.SeasonNumber,
            episode: editorial.episodeNumber,
        };
    }

    const contentId = contentRef || id;

    if (type === RBAssetType.EDITORIAL) {
        return {
            filterType: DetailsRequestUrlType.VOD,
            id,
            editorialId: contentId,
            programId: editorial?.technicals?.[0].ProgramId,
            channelId,
        };
    }

    if (contentId) {
        return {
            filterType: DetailsRequestUrlType.PROGRAM,
            id,
            channelId,
            contentRef: contentId,
        };
    }

    return {
        filterType: DetailsRequestUrlType.PROGRAM,
        id,
        channelId,
    };
}

export default getRBBtvProgrammeDetailsParams;
